import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { ui } from "../lib/ui";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      const dest = location.state?.from || (u.role === "admin" ? "/admin" : "/archive");
      navigate(dest);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-16">
      <h1 className="font-serif text-3xl font-bold text-[#8B1A1A] mb-2">Log in</h1>
      <p className="text-sm text-[#5A4441] mb-8">Access your account and member features.</p>
      <form onSubmit={submit} className={ui.card + " p-6 space-y-5"} data-testid="login-form">
        <div>
          <label className={ui.label}>Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={ui.input} data-testid="login-email-input" />
        </div>
        <div>
          <label className={ui.label}>Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={ui.input} data-testid="login-password-input" />
        </div>
        <button type="submit" disabled={loading} className={ui.btnPrimary + " w-full"} data-testid="login-submit-btn">
          {loading ? "Logging in…" : "Log in"}
        </button>
        <div className="text-center">
          <Link to="/forgot-password" className="text-sm text-[#8B1A1A] underline" data-testid="login-forgot-link">Forgot password?</Link>
        </div>
      </form>
      <p className="text-sm text-[#5A4441] mt-5 text-center">
        No account? <Link to="/register" className="text-[#8B1A1A] underline">Create one</Link>
      </p>
    </div>
  );
}
